export const AND_SEPARATOR = ";";
export const OR_SEPARATOR = ",";
export const ASSIGNMENT_SEPARATOR = "=";

export const AND_FILTER = "and";
export const OR_FILTER = "or";

export const EQUALS_OPERATOR = "equals";
export const IS_OPERATOR = "is";
export const IS_ANY_OF = "isAnyOf";
export const RANGE_OPERATOR = "range";
export const STARTS_WITH_OPERATOR = "startsWith";
export const ENDS_WITH_OPERATOR = "endsWith";
export const CONTAINS_OPERATOR = "contains";
export const ON_OR_AFTER_OPERATOR = "onOrAfter";
export const ON_OR_BEFORE_OPERATOR = "onOrBefore";
export const IS_EMPTY_OPERATOR = "isEmpty";
export const ON_OPERATOR = "on";

export const FILTER_ITEM_TYPE = {
  SELECT: "select",
  DATE: "date",
  WEEK: "week",
  CHECKBOX: "checkbox",
  MULTI_SELECT: "multiSelect",
};

export const OPERATORS = {
  EQUALS: "==",
  CONTAINS: "contains",
  STARTS_WITH: "startsWith",
  ENDS_WITH: "endsWith",
  GREATER_THAN: ">",
  LESS_THAN: "<",
  GREATER_THAN_OR_EQUAL: ">=",
  LESS_THAN_OR_EQUAL: "<=",
  IN_RANGE: "inRange",
  RANGE: "range",
};

export const OPERATOR_LIST = [
  EQUALS_OPERATOR,
  IS_OPERATOR,
  IS_ANY_OF,
  RANGE_OPERATOR,
  STARTS_WITH_OPERATOR,
  ENDS_WITH_OPERATOR,
  CONTAINS_OPERATOR,
  ON_OR_AFTER_OPERATOR,
  ON_OR_BEFORE_OPERATOR,
  IS_EMPTY_OPERATOR,
  ON_OPERATOR,
];
